import { ASSESSMENT_PROTOCOL } from '../constants';
import { getAssessmentPosteriorMedian, resolveAssessmentBand } from '../posterior';
import type { AssessmentPosteriorType, IAssessmentResult } from '../types';

interface IBuildAssessmentResultParams {
  attemptId: string;
  completedAt: number;
  posterior: AssessmentPosteriorType;
}

export function buildAssessmentResult({
  attemptId,
  completedAt,
  posterior,
}: IBuildAssessmentResultParams): Readonly<IAssessmentResult> {
  const band = resolveAssessmentBand(getAssessmentPosteriorMedian(posterior));
  return Object.freeze({
    assessmentVersion: ASSESSMENT_PROTOCOL.assessmentVersion,
    attemptId,
    cefr: band.cefr,
    completedAt,
    score: band.score,
    subBand: band.subBand,
  });
}
